import { useCallback } from "react";

import useClient from "hooks/useClient";

const useCreateOption = () => {
  const { client } = useClient();

  const createOption = useCallback(
    async ({
      name,
      requestService,
      orderId,
      otherRequestContent,
      province,
      district,
      street,
      remarks,
      kizukuSpotId,
    }) => {
      const { status } = await client({
        method: "post",
        url: `/option`,
        data: {
          name,
          requestService,
          orderId,
          otherRequestContent,
          province,
          district,
          street,
          others: remarks,
          kizukuSpotId,
        },
      });
      return status;
    },
    [client]
  );

  return { createOption };
};

export default useCreateOption;
